export default "__VITE_ASSET__d8a8bcad__"